// extracted by mini-css-extract-plugin
export var alt = "SearchMessage-module--alt--346e5";
export var desktopOnly = "SearchMessage-module--desktopOnly--b9775";
export var main = "SearchMessage-module--main--58e32";
export var message = "SearchMessage-module--message--504b6";
export var mobileOnly = "SearchMessage-module--mobileOnly--1edf6";
export var textLeft = "SearchMessage-module--textLeft--77a4a";
export var visuallyHidden = "SearchMessage-module--visuallyHidden--3ba39";
export var wrapper = "SearchMessage-module--wrapper--5b8db";